export enum NotificationResult {
    None = 0,
    OK = 1,
    Cancel = 2,
    Abort = 3,
    Retry = 4,
    Ignore = 5,
    Yes = 6,
    No = 7
}

export enum TypeMessage {
    Confirm,
    Alert
}

class BaseMessage {
    constructor(private customfunc: (message: string, deferred: JQueryDeferred<NotificationResult>) => JQueryPromise<{}>) {
    }

    ExeFunc(message: string): JQueryPromise<{}> {
        let defer: JQueryDeferred<NotificationResult> = $.Deferred();
        this.customfunc(message, defer);
        return defer.promise();
    };
}

export function setupMessage(type: TypeMessage, customfunction: (message: string, deferred: JQueryDeferred<NotificationResult>) => JQueryPromise<{}>): void {
    if (type == TypeMessage.Alert) {
        (<any>window).SyntessTS.UI.windowAlertMessage = new BaseMessage(customfunction);
    } else if (type == TypeMessage.Confirm) {
        (<any>window).SyntessTS.UI.windowConfirmMessage = new BaseMessage(customfunction);
    }
}

export function showConfirm(message: string): JQueryPromise<{}> {
    let _window = <any>window;
    if (isWindowProperty("windowConfirmMessage")) {
        return _window.SyntessTS.UI.windowConfirmMessage.ExeFunc(message);
    } else {
        throw new ReferenceError("ConfirmFunc does not exist on window object");
    }
}

export function showAlert(message: string): JQueryPromise<{}> {
    let _window = <any>window;
    if (isWindowProperty("windowAlertMessage")) {
        return _window.SyntessTS.UI.windowAlertMessage.ExeFunc(message);
    } else {
        throw new ReferenceError("AlertFunc does not exist on window object");
    }
}

function isWindowProperty(propName: string) {
    let _window = <any>window;
    return _window.SyntessTS && _window.SyntessTS.UI && _window.SyntessTS.UI[propName];
}

/**
* Set de defaultoptions en bewerkt bepaalde elementen voor jquerydialoog
* @param title Titel voor het dialoog
* @param elem  Het element (meestal een div) wat gebruikt moet worden voor de bouwen van de popup
* @param options Extra opties die meegegeven kunnen worden
* @returns Nothing
*/
export function ShowPopup(title: string, elem: string | JQuery | Element, options?: JQueryUI.DialogOptions): void {
    // default settings
    let startOptions: JQueryUI.DialogOptions = {
        create: function (_event: Event, _ui: JQueryUI.DialogUIParams) {
            $(".ui-dialog-titlebar-close").attr("tabindex", "-1");

            $(this).on("dialogopen", function () {
                $('body').addClass('body-dialog--open');
            }).on("dialogclose", function () {
                $('body').removeClass('body-dialog--open');
            });

            // De closeText-option binnen het create-event zetten zodat het sluiticoon niet wordt vervangen wanneer
            // element.dialog(settings) redundant wordt aangeroepen op een dialoog-element wat al gecreeerd en geopend is.
            $(this).dialog({ closeText: "" });
            let dialogHeaderCloseElement: JQuery = $(this).parent().find(".dialog__header__close");
            if (dialogHeaderCloseElement.length > 0) {
                dialogHeaderCloseElement.addClass('wbButton--iconOnly').append('<svgplaceholder iconname="times"></svgplaceholder>');
            }
        },
        open: function () {
            $(this).parent().focus();
        },
        close: function () {
            $(this).dialog("destroy");
        },
        title: title,
        modal: true,
        resizable: false,
        draggable: false,
        show: 'fade',
        hide: 'fade'
    };
    let settings = $.extend(true, startOptions, options || {});

    $(elem).dialog(settings);
};

/**
* Set de defaultoptions en bewerkt bepaalde elementen voor jquerydialoog
* @param title Titel voor het dialoog
* @param divid  Het id van een element (meestal een div) wat gebruikt moet worden voor de bouwen van de popup
* @param options Extra opties die meegegeven kunnen worden
* @returns Nothing
*/
export function ShowPopupWithId(title: string, divid: string, options?: JQueryUI.DialogOptions): void {
    ShowPopup(title, $("#" + divid), options);
};
